export default __webpack_public_path__ + "static/media/img-intro-overview-en@2x.eb20e6cf.png";